import tinycolor from "tinycolor2";
import { useSelectTheme } from "../store";

export const darken = (color: tinycolor.ColorInput, amount: number) => {
  return tinycolor(color).darken(amount).toString();
};

export const lighten = (color: tinycolor.ColorInput, amount: number) => {
  return tinycolor(color).lighten(amount).toString();
};

export const brighten = (color: tinycolor.ColorInput, amount: number) => {
  return tinycolor(color).brighten(amount).toString();
};

export const setAlpha = (color: tinycolor.ColorInput, amount: number) => {
  return tinycolor(color).setAlpha(amount).toString();
};

export const createColorTranslator = <T>(colors: readonly T[]): ((colorIndex: number) => T) => {
  const total = colors.length;
  return (colorIndex) => colors[colorIndex % total];
};

export const useCreateTaskColorTranslator = () => {
  const { taskColorList } = useSelectTheme();
  return createColorTranslator(taskColorList);
};
